var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _c(
              "div",
              { staticClass: "m-b-xs-20" },
              [
                _c(
                  "ak-button",
                  { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                  [
                    _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                      _vm._v("arrow_left"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Ga terug")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-8" }, [
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  { staticClass: "ak-panel__header ak-panel__header--small" },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("Antwoorden")) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                !_vm.loading
                  ? _c("table", { staticClass: "ak-table ak-panel__table" }, [
                      _c(
                        "tbody",
                        _vm._l(_vm.answers, function (answer) {
                          return _c(
                            "tr",
                            { key: answer.id, staticClass: "ak-table-row" },
                            [
                              _c("td", { staticClass: "ak-table-column" }, [
                                _c("i", [
                                  _vm._v(_vm._s(answer.question.question)),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("b", [_vm._v(_vm._s(answer.value))]),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4" }, [
            _c(
              "div",
              { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
              [
                _c(
                  "div",
                  { staticClass: "ak-panel__header ak-panel__header--small" },
                  [
                    _c("div", { staticClass: "ak-panel__title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("Deelnemer")) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                !_vm.loading
                  ? _c("table", { staticClass: "ak-table ak-panel__table" }, [
                      _c("tbody", [
                        _vm.supplier
                          ? _c("tr", { staticClass: "ak-table-row" }, [
                              _c("td", { staticClass: "ak-table-column" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openSupplierForm.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.$t("Leverancier")) +
                                        ": " +
                                        _vm._s(_vm.supplier.title) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.participant.name) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "ak-table-row" }, [
                          _c("td", { staticClass: "ak-table-column" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.participant.email) +
                                "\n                                "
                            ),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "childview" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }